import { Card, Stack, Typography, useTheme } from '@mui/joy';

import { ChatbotConversationDirection } from 'chatbot/types';
import { Button, IButtonProps } from 'core/components';
import { Color, Direction, Level, Variant } from 'theme/enums';

interface IProps {
  direction?: ChatbotConversationDirection;
  message: string;
  buttons?: IButtonProps[];
}

export const ConversationMessage = ({ direction, message, buttons }: IProps) => {
  const theme = useTheme();

  return (
    <Card
      sx={{
        minWidth: 320,
        backgroundColor: theme.palette.neutral[200],
        alignSelf: direction
          ? direction === ChatbotConversationDirection.OUTGOING
            ? 'flex-end'
            : 'flex-start'
          : 'center',
      }}
    >
      <Typography level={Level.BODY_MD}>{message}</Typography>
      <Stack direction={Direction.ROW} gap={1} justifyContent="flex-end">
        {buttons?.map((button) => (
          <Button
            key={button.text as string}
            variant={Variant.PLAIN}
            color={Color.NEUTRAL}
            {...button}
          />
        ))}
      </Stack>
    </Card>
  );
};
